<template>
  <b-modal :id="modalId" centered modal-class="db-modal" @show="showModal" @hidden="hiddenModal">
    <template #modal-header>
      <div class="db-modal-head">
        <h2 class="db-modal-title">{{ url ? "Editar enlace" : "Nuevo enlace" }}</h2>
        <p class="db-modal-subtitle">El título, la descripción y la imagen se obtienen automáticamente de la página.</p>
      </div>
      <button type="button" class="db-icon-btn" aria-label="Cerrar" @click="closeModal">
        <span class="material-symbols-outlined">close</span>
      </button>
    </template>

    <form class="db-form" @submit.prevent="actualizarURL">
      <div class="db-field">
        <label class="db-label" for="mu-url">Dirección web</label>
        <input
          id="mu-url"
          v-model.trim="enlaceUrl"
          type="url"
          class="db-input"
          :class="{ 'is-invalid': enlaceUrl && !urlValida }"
          placeholder="https://www.ejemplo.com"
        />
        <p v-if="enlaceUrl && !urlValida" class="db-hint mu-error">Escribe la dirección completa, empezando por https://</p>
      </div>

      <div class="db-field mu-posicion">
        <label class="db-label" for="mu-pos">Posición</label>
        <input id="mu-pos" v-model.number="posicion" type="number" min="0" step="1" class="db-input" placeholder="Al final" />
        <p class="db-hint">Los números más bajos aparecen primero. Déjalo vacío para ponerlo al final.</p>
      </div>

      <label class="db-switch">
        <input v-model="visible" type="checkbox" />
        <span class="db-switch-track"></span>
        Mostrar en la web
      </label>
    </form>

    <template #modal-footer>
      <button type="button" class="db-btn db-btn--ghost" @click="closeModal">Cancelar</button>
      <button type="button" class="db-btn" :disabled="!urlValida || guardando" @click="actualizarURL">
        <span v-if="guardando" class="db-spinner"></span>
        {{ url ? "Guardar cambios" : "Añadir enlace" }}
      </button>
    </template>
  </b-modal>
</template>

<script>
import axios from "@/directives/axios.js";
import { avisar, avisarError } from "@/directives/dbDialogs.js";

export default {
  name: "modalUrl",
  props: ["modalId", "url"],
  data() {
    return {
      enlaceUrl: "",
      posicion: "",
      visible: true,
      guardando: false,
    };
  },
  computed: {
    urlValida() {
      try {
        const u = new URL(this.enlaceUrl);
        return u.protocol === "http:" || u.protocol === "https:";
      } catch (e) {
        return false;
      }
    },
  },
  methods: {
    hiddenModal() {
      this.enlaceUrl = "";
      this.posicion = "";
      this.visible = true;
      this.guardando = false;
    },
    showModal() {
      if (this.url) {
        this.enlaceUrl = this.url.url;
        this.posicion = this.url.posicion != null ? Number(this.url.posicion) : "";
        this.visible = this.url.activo == 1 || this.url.activo === true;
      }
    },
    async actualizarURL() {
      if (!this.urlValida) return;
      this.guardando = true;
      try {
        const respuesta = await axios.post("/enlaces/editar", {
          id: this.url ? this.url.id : null,
          url: this.enlaceUrl,
          visible: this.visible,
          // null = la API lo coloca al final (solo al crear; al editar conserva la actual)
          posicion: Number.isInteger(this.posicion) && this.posicion >= 0 ? this.posicion : null,
        });
        avisar(this, `${this.enlaceUrl} ${this.visible ? "aparece" : "está oculto"} en la portada.`, "success", this.url ? "Enlace modificado" : "Enlace añadido");
        this.$emit("obtenerEnlacesInteres", respuesta);
        this.closeModal();
      } catch (error) {
        avisarError(this, error, "No se pudo guardar el enlace. Revisa la dirección.");
      } finally {
        this.guardando = false;
      }
    },
    closeModal() {
      this.$bvModal.hide(this.modalId);
    },
  },
};
</script>

<style scoped>
.mu-posicion .db-input {
  max-width: 140px;
}

.mu-error {
  color: var(--sd-danger);
}
</style>
